/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreviewQueryRequest } from '../../models/preview-query-request';
import { QueryResultDto } from '../../models/query-result-dto';

export interface QueryExecutionPreviewPost$Json$Params {
  dataSourceId?: string;
      body?: PreviewQueryRequest
}

export function queryExecutionPreviewPost$Json(http: HttpClient, rootUrl: string, params?: QueryExecutionPreviewPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
  const rb = new RequestBuilder(rootUrl, queryExecutionPreviewPost$Json.PATH, 'post');
  if (params) {
    rb.query('dataSourceId', params.dataSourceId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryResultDto>;
    })
  );
}

queryExecutionPreviewPost$Json.PATH = '/query-execution/preview';
